import { __assign, __awaiter, __extends, __generator } from "tslib";
import React, { useState, useEffect } from 'react';
import { ConfigContextProvider, useConfigContext, } from './config-context';
import { TranslationsProvider } from './i18next';
import { Origin, Path } from './enums/marketplace-enums';
import { ExperimentsProvider } from '@wix/wix-experiments-react';
import { BiProvider, biLogger } from './bi';
import { MarketplaceLayout } from './components/marketplace-layout';
import { setConfig } from './config';
import s from './marketplace.scss';
import { configureScope } from '@sentry/browser';
import { MarketplaceStoreProvider, } from './component-decorators/with-marketplace-store';
import { fetchBundleApps, fetchCurrentBundleApps, fetchSiteData, } from './api/api';
import { WithFetcher, } from './component-decorators/with-fetcher';
import { CenteredLoader } from './components/centered-loader';
import { StandaloneHeader } from './components/standalone-header';
import { Modals } from './components/modals/modals';
import { MobileMenu } from './components/mobile-menu';
import { MobileSearchBox } from './components/search-box/mobile-search-box';
import { getPathForBi, getReferralInfo } from './common/bi-events';
import { composer } from './component-decorators/composer';
import { getInstalledApps } from './common/utils';
import { FontUpgrade, WixStyleReactProvider } from 'wix-style-react';
var dataFetcher = function (metaSiteId, signedInstance, geoString) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, siteData, bundleApps, currentBundleApps;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, Promise.all([
                    fetchSiteData(metaSiteId),
                    fetchBundleApps(signedInstance, geoString),
                    fetchCurrentBundleApps(signedInstance, geoString),
                ])];
            case 1:
                _a = _b.sent(), siteData = _a[0], bundleApps = _a[1], currentBundleApps = _a[2];
                return [2 /*return*/, {
                        siteData: siteData,
                        bundleApps: bundleApps,
                        currentBundleApps: currentBundleApps,
                    }];
        }
    });
}); };
var Marketplace = /** @class */ (function (_super) {
    __extends(Marketplace, _super);
    function Marketplace(props) {
        var _this = _super.call(this, props) || this;
        console.log("marketplace-component/src/marketplace.tsx file - line 137 - " + Date.now());
        var goto = props.goto, baseApiUrl = props.baseApiUrl, origin = props.origin, marketplaceStaticsUrl = props.marketplaceStaticsUrl, route = props.route, metaSiteId = props.metaSiteId, goToHomePage = props.goToHomePage, goToManageApps = props.goToManageApps, goBackToReferrer = props.goBackToReferrer, installApp = props.installApp, editorUrl = props.editorUrl, editorType = props.editorType, manageAppsMainButtonAction = props.manageAppsMainButtonAction, manageAppsStaticsUrl = props.manageAppsStaticsUrl, sentryClient = props.sentryClient;
        biLogger.util.updateDefaults({
            msid: metaSiteId,
            market: _this.props.origin === Origin.BIZMGR ? 'dashboard' : _this.props.origin,
        });
        configureScope(function (scope) {
            scope.setTag('component', 'marketplace-component');
        });
        setConfig({
            goto: goto,
            baseApiUrl: baseApiUrl,
            origin: origin,
            marketplaceStaticsUrl: marketplaceStaticsUrl,
            goToHomePage: goToHomePage,
            goToManageApps: goToManageApps,
            goBackToReferrer: goBackToReferrer,
            installApp: installApp,
            editorUrl: editorUrl,
            editorType: editorType,
            manageAppsMainButtonAction: manageAppsMainButtonAction,
            manageAppsStaticsUrl: manageAppsStaticsUrl,
            sentryClient: sentryClient,
        });
        return _this;
    }
    Marketplace.prototype.componentDidMount = function () {
        var route = this.props.route;
        // tslint:disable-next-line: no-floating-promises
        biLogger.marketOpened({
            tag_name: route.slug || route.query || 'homepage',
            tag_type: getPathForBi(route.path),
            referral_info: getReferralInfo(route.referral),
        });
    };
    Marketplace.prototype.render = function () {
        var _a = this.props, showHeader = _a.showHeader, hideSearchInMenu = _a.hideSearchInMenu, experimentsBag = _a.experimentsBag, metaSiteId = _a.metaSiteId, locale = _a.locale, i18n = _a.i18n, ssrMemo = _a.ssrMemo, baseUrl = _a.baseUrl, route = _a.route, metaTagsAggregator = _a.metaTagsAggregator, isMobile = _a.isMobile, isAppOnStage = _a.isAppOnStage, closeMarket = _a.closeMarket, finishAppInstall = _a.finishAppInstall, openApp = _a.openApp, getAppInstance = _a.getAppInstance, countryCode = _a.countryCode, showUserActionNotification = _a.showUserActionNotification, shouldUseSupportModal = _a.shouldUseSupportModal, unInstallApp = _a.unInstallApp, responseCode = _a.responseCode, openPackagePicker = _a.openPackagePicker, userName = _a.userName, hideBusinessSolutionsInManageApps = _a.hideBusinessSolutionsInManageApps, userImage = _a.userImage, origin = _a.origin, rpcClient = _a.rpcClient;
        var shouldHideMenu = route.path === Path.SHARE;
        var currentRoute = shouldHideMenu ? __assign(__assign({}, route), { hideMenu: true }) : route;
        var configContext = {
            locale: locale,
            i18n: i18n,
            ssrMemo: ssrMemo,
            baseUrl: baseUrl,
            route: route,
            metaTagsAggregator: metaTagsAggregator,
            isMobile: isMobile,
            isAppOnStage: isAppOnStage,
            closeMarket: closeMarket,
            finishAppInstall: finishAppInstall,
            openApp: openApp,
            getAppInstance: getAppInstance,
            countryCode: countryCode,
            showUserActionNotification: showUserActionNotification,
            shouldUseSupportModal: shouldUseSupportModal,
            unInstallApp: unInstallApp,
            responseCode: responseCode,
            openPackagePicker: openPackagePicker,
            rpcClient: rpcClient,
        };
        return (React.createElement("div", { className: s.marketplaceRoot, "data-hook": "marketplace" },
            React.createElement(ConfigContextProvider, { value: configContext },
                React.createElement(TranslationsProvider, null,
                    React.createElement(ExperimentsProvider, { options: { experiments: experimentsBag } },
                        React.createElement(MarketplaceStoreProvider, { hideBusinessSolutionsInManageApps: hideBusinessSolutionsInManageApps, userImage: userImage, userName: userName, metaSiteId: metaSiteId, prevRoute: null, route: currentRoute },
                            React.createElement(BiProvider, { value: biLogger },
                                React.createElement(MarketplaceComponent, { key: 'marketplaceComponent', showHeader: showHeader, hideSearchInMenu: hideSearchInMenu, msId: metaSiteId, route: route, origin: origin }))))))));
    };
    return Marketplace;
}(React.Component));
export { Marketplace };
export var MarketplaceComponentBase = composer()
    .withMarketplaceStore()
    .withExperiments()
    .compose(function (_a) {
    var marketplaceStore = _a.marketplaceStore, fetchData = _a.fetchData, showHeader = _a.showHeader, hideSearchInMenu = _a.hideSearchInMenu, signedInstance = _a.signedInstance;
    // tslint:disable-next-line: react-hooks-nesting
    var _b = useState(false), isMobileMenuOpen = _b[0], setIsMobileMenuOpen = _b[1];
    // tslint:disable-next-line: react-hooks-nesting
    var _c = useState(false), isSearchMenuOpen = _c[0], setIsSearchMenuOpen = _c[1];
    var shouldHaveOverlay = function () { return isMobileMenuOpen || isSearchMenuOpen; };
    // tslint:disable-next-line: react-hooks-nesting
    useEffect(function () {
        var _a, _b;
        marketplaceStore.setSiteIsPremium((_a = fetchData === null || fetchData === void 0 ? void 0 : fetchData.siteData) === null || _a === void 0 ? void 0 : _a.siteIsPremium);
        marketplaceStore.setSiteHasDomain((_b = fetchData === null || fetchData === void 0 ? void 0 : fetchData.siteData) === null || _b === void 0 ? void 0 : _b.siteIsPremium);
        marketplaceStore.setBundleApps((fetchData === null || fetchData === void 0 ? void 0 : fetchData.bundleApps) || []);
        marketplaceStore.setCurrentBundleApps((fetchData === null || fetchData === void 0 ? void 0 : fetchData.currentBundleApps) || []);
        getInstalledApps(signedInstance).then(function (apps) {
            marketplaceStore.setInstalledApps(apps);
            console.log('after fetch');
        });
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Modals, null),
        showHeader && (React.createElement(StandaloneHeader, { toggleSearchBox: function () { return setIsSearchMenuOpen(!isSearchMenuOpen); }, toggleMenu: function () { return setIsMobileMenuOpen(!isMobileMenuOpen); } })),
        showHeader && (React.createElement(React.Fragment, null,
            React.createElement(MobileMenu, { toggleMenu: function () { return setIsMobileMenuOpen(!isMobileMenuOpen); }, isMenuOpen: isMobileMenuOpen }),
            React.createElement(MobileSearchBox, { toggleSearchBox: function () { return setIsSearchMenuOpen(!isSearchMenuOpen); }, isSearchMenuOpen: isSearchMenuOpen }),
            shouldHaveOverlay() && React.createElement("div", { className: s.overlay }))),
        React.createElement(MarketplaceLayout, { hideSearchInMenu: hideSearchInMenu })));
});
export var MarketplaceComponent = composer()
    .withExperiments()
    .withMarketplaceStore()
    .compose(function (_a) {
    var showHeader = _a.showHeader, hideSearchInMenu = _a.hideSearchInMenu, msId = _a.msId, experiments = _a.experiments, route = _a.route, origin = _a.origin, marketplaceStore = _a.marketplaceStore;
    // tslint:disable-next-line: react-hooks-nesting
    var _b = useConfigContext(), getAppInstance = _b.getAppInstance, countryCode = _b.countryCode;
    var signedInstance = getAppInstance
        ? getAppInstance('22bef345-3c5b-4c18-b782-74d4085112ff')
        : undefined;
    var reducedSpacing = experiments === null || experiments === void 0 ? void 0 : experiments.enabled('specs.marketplace.reducedSpacing');
    var shouldSendGeo = experiments.enabled('specs.marketplace.bundle-on-geo');
    var geoString = shouldSendGeo ? countryCode : '';
    useEffect(function () {
        marketplaceStore.setMetaSiteId(msId);
        marketplaceStore.setRoute(route);
        biLogger.util.updateDefaults({
            msid: msId,
            market: origin === Origin.BIZMGR ? 'dashboard' : origin,
        });
    }, [route, msId, origin]);
    return (React.createElement(WithFetcher, { loader: React.createElement(CenteredLoader, null), initialFetch: function () { return dataFetcher(msId, signedInstance, geoString); }, fetchMemoizationId: "marketplaceComponent" }, function (_a) {
        var fetchData = _a.fetchData, reFetch = _a.reFetch;
        return (React.createElement(WixStyleReactProvider, { features: { reducedSpacingAndImprovedLayout: reducedSpacing }, as: 'span' },
            React.createElement(FontUpgrade, null,
                React.createElement(MarketplaceComponentBase, { key: 'marketplaceComponent', showHeader: showHeader, hideSearchInMenu: hideSearchInMenu, msId: msId, fetchData: fetchData, reFetch: reFetch, signedInstance: signedInstance, geoString: geoString }))));
    }));
});
//# sourceMappingURL=marketplace.js.map